import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  LOAN_APPLICATION_UPDATE_SUCCESS,
  UPDATE_FINANCIALS_SUCCESS,
  UPDATE_EXPENSE_SUCCESS,
  UPDATE_INCOME_SUCCESS,
  UPDATE_COMMITMENTS_SUCCESS,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_LOAN_DETAIL_SUCCESS,
  UPDATE_LOAN_SUMMARY_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
  LOAN_APPLICATION_USER_VERIFY_SUCCESS,
  UPDATE_EMPLOYMENTS_SUCCESS,
  UPDATE_DECLARATION_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
  UPDATE_READYFORFINAL_SUCCESS, INCOME_SOURCE_CHANGED, INCOME_EMPLOYER_TYPE_CHANGED,
} from './../actions/types'

const loanApplicationUser = (state={}, {type, payload}) => {
  switch(type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      return { primary: payload.applicationFlow.loanApplicationUser, secondary: payload.applicationFlow.loanApplicationSecondaryUser }

    case UPDATE_FINANCIALS_SUCCESS:
    case UPDATE_EXPENSE_SUCCESS:
    case LOAN_APPLICATION_UPDATE_SUCCESS:
    case UPDATE_COMMITMENTS_SUCCESS:
    case UPDATE_ASSETS_SUCCESS:
    case UPDATE_LOAN_DETAIL_SUCCESS:
    case UPDATE_PROFILE_SUCCESS:
    case LOAN_APPLICATION_USER_VERIFY_SUCCESS:
    case UPDATE_EMPLOYMENTS_SUCCESS:
    case UPDATE_DECLARATION_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case UPDATE_LOAN_SUMMARY_SUCCESS:
    case UPDATE_READYFORFINAL_SUCCESS:
      window.scrollTo({top: 0})
      return { primary: payload.loanApplicationUser, secondary: payload.loanApplicationSecondaryUser } || state
    case UPDATE_INCOME_SUCCESS:
      return { primary: payload.loanApplicationUser, secondary: payload.loanApplicationSecondaryUser }
    case INCOME_SOURCE_CHANGED:
      const incomeSource = payload && payload.value ? payload.value : payload
      state[payload.currentApplicant].incomeSource = incomeSource
      return { ...state }
    case INCOME_EMPLOYER_TYPE_CHANGED:
      const incomeEmployerType = payload && payload.value ? payload.value : payload
      state[payload.currentApplicant].incomeEmployerType = incomeEmployerType
      return {
        ...state,
      }
    default:
      return state
  }
}

export const getProgressBarValue = (state) => (state.progressValue || 0)
export const getFlowState = (state) => state.flowState
export const getSidebar = (state) => state.sidebar

const currentApplicant = (applicant) => {
  return applicant.primary.flowState.includes('secondary') ? applicant.secondary : applicant.primary;
}

export const getFirstName = (state) => {
  const applicant = currentApplicant(state);
  return applicant.firstname
}
export const getMiddleName = (state) => {
  const applicant = currentApplicant(state);
  return applicant.middlename
}
export const getSurname = (state) => {
  const applicant = currentApplicant(state);
  return applicant.surname
}

export const getEmail = (state) => {
  const applicant = currentApplicant(state);
  return applicant.email
}

export const getMobile = (state) => {
  const applicant = currentApplicant(state);
  return applicant.mobile
}

export default loanApplicationUser;
